import "core-js/modules/es.string.sub.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0c7e3027"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "origin"
};
var _hoisted_2 = {
  class: "firorg"
};
var _hoisted_3 = {
  class: "orgname"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "orgLine"
  }, null, -1);
});

var _hoisted_5 = {
  class: "children"
};
var _hoisted_6 = ["onClick"];

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});

var _hoisted_8 = {
  class: "tree-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$orgList$root;

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(((_ctx$orgList$root = _ctx.orgList.root) === null || _ctx$orgList$root === void 0 ? void 0 : _ctx$orgList$root.orgName) || "无"), 1)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgList.sub, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "tree-item",
      onClick: function onClick($event) {
        return _ctx.handleSubClick(item);
      }
    }, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(item.orgName), 1)], 8, _hoisted_6);
  }), 128))])]);
}